import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Snackbar,
  Alert,
  CircularProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Link,
  IconButton
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import { investorApi } from "../../api/api";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const ProjectDocument = ({ data, userId, type }) => {
  const [requestSubmitted, setRequestSubmitted] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  

      const openPdf = (url) => {
    window.open(url, "_blank");
  };

  // Build payload
  const payload = {
    userId,
    PropertyType: type,
    ...(type === 1 && { projectId: data }),
    ...(type === 2 && { propertyId: data }),
    ...(type === 3 && { apartmentId: data }),
    ...(type === 4 && { propertyId: data }),
  };
  const fetchStatusAndDocuments = async () => {
    setLoading(true);
    try {
      const response = await investorApi.getPropertyDocumentStatus(payload);
      setRequestSubmitted(response.data.requestSubmitted);
      setDocuments(response.data.documents);
    } catch (error) {
      console.error("Error fetching document status", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatusAndDocuments();
  }, []);

  // const handleRequestClick = async () => {
  //   try {
  //     await investorApi.addDocumentRequests(payload);
  //     setRequestSubmitted(true);
  //     setSnackbarOpen(true);
  //   } catch (error) {
  //     console.error("Document request failed", error);
  //   }
  // };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Box sx={{  ml: 2, backgroundColor: "white", borderRadius: 5, padding: 5 }}>
      <Typography variant="h6" fontWeight={600} gutterBottom>
        Project Documents
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 2 }}>
          <CircularProgress size={24} />
          <Typography>Loading...</Typography>
        </Box>
      ) : documents.length > 0 ? (
        <List>
          {documents.map((doc, idx) => (
             <Box
              key={doc.id}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 1,
                mb: 1,
                borderRadius: 1,
                backgroundColor: "#f5f5f5",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PictureAsPdfIcon color="error" />
                <Typography>{doc.DocumentName}</Typography>
              </Box>
              <Box>
                <IconButton onClick={() => openPdf(doc.DocumentURL)} aria-label="view" size="small">
                  <OpenInNewIcon />
                </IconButton>
              </Box>
            </Box>
          ))}
        </List>
      ) : requestSubmitted ? (
        <Typography sx={{ mt: 2, color: "orange" }}>
          Request submitted. Waiting for admin to upload documents...
        </Typography>
      ) :(
        // ❗ Default fallback: no documents and no request submitted
        <Typography sx={{ mt: 2, color: "text.secondary" }}>
          No documents available.
        </Typography>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: "100%" }}>
          Your request has been submitted.
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ProjectDocument;
